export const CRITERIO_COBRANCA_UNICA = 0
export const CRITERIO_COBRANCA_RECORRENTE = 1
export const CRITERIO_COBRANCA_POR_USO = 2

export const CriteriosCobranca = {
    [CRITERIO_COBRANCA_UNICA]: {title: 'Uma vez'},
    [CRITERIO_COBRANCA_RECORRENTE]: {title: 'Recorrente'},
    [CRITERIO_COBRANCA_POR_USO]: {title: 'Por uso'}
}
